import { render, staticRenderFns } from "./photoSlider.vue?vue&type=template&id=0c18ce80&scoped=true&"
import script from "./photoSlider.vue?vue&type=script&lang=js&"
export * from "./photoSlider.vue?vue&type=script&lang=js&"
import style0 from "./photoSlider.vue?vue&type=style&index=0&id=0c18ce80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c18ce80",
  null
  
)

export default component.exports